/* eslint-disable react/prefer-stateless-function */
import PropTypes from "prop-types";
import Cleave from "cleave.js/react";

const cleaveOptions = {
  date: { blocks: [4, 2, 2], delimiter: "-", numericOnly: false },
  dateandtime: { blocks: [4, 2, 8], delimiter: "-", numericOnly: false },
};

export const CleaveInput = (props) => {
  const { id, inputRef, type, ...rest } = props;
  return (
    <Cleave ref={inputRef} options={cleaveOptions[type]} id={id} {...rest} />
  );
};

CleaveInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
};
